// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';


//page component

import FIcontent from './PageComponent/FIcontent';

function FilterInspiration() {

    useMeta({
        title: 'Filter Inspiration | Callistus Blinds',
        description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
        canonical: 'https://callistusblinds.com/filter-inspiration/',
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Filter Inspiration | Callistus Blinds',
            description:
                'Coming Soon',
            url: 'https://callistusblinds.com/filter-inspiration/',
            site_name: 'Callistus Blinds',
        },
    });

    return (
        <div>
            <Navbar />
            <FIcontent />
            <Footer />
        </div>
    );
}

export default FilterInspiration;
